import React from 'react';
import { List, ListItem, ListItemSecondaryAction, ListItemText, ListProps } from '@mui/material';

import { produce } from 'immer';
import { Channel, ProductApi } from 'common/types';
import { useTranslation } from 'services/localization';
import VisibilitySwitch from './VisibilitySwitch';

export interface ChannelVisibilitySettingsProps extends Omit<ListProps, 'onChange'> {
	hiddenChannels: ProductApi['hiddenFromChannels'];
	onChange: (value: ProductApi['hiddenFromChannels']) => void;
	disabled?: boolean;
}
const ChannelVisibilitySettings = (props: ChannelVisibilitySettingsProps) => {
	const { t } = useTranslation();
	const { hiddenChannels = {}, onChange, disabled, ...listProps } = props;

	const isChannelEnabled = (channel: Channel) => {
		return !hiddenChannels[channel];
	};

	const toggleChannel = (channel: Channel) => (checked: boolean) => {
		onChange(
			produce(hiddenChannels, (draft) => {
				if (checked) {
					delete draft[channel];
				} else {
					draft[channel] = true;
				}
			}),
		);
	};

	return (
		<List {...listProps}>
			<ListItem divider>
				<ListItemText primary={t('common:salesChannel.online', 'Online')} />
				<ListItemSecondaryAction>
					<VisibilitySwitch
						checked={isChannelEnabled('ONLINE')}
						onChange={toggleChannel('ONLINE')}
						disabled={disabled}
					/>
				</ListItemSecondaryAction>
			</ListItem>
			<ListItem divider>
				<ListItemText primary={t('common:salesChannel.adminDashboard', 'Admin dashboard')} />
				<ListItemSecondaryAction>
					<VisibilitySwitch
						checked={isChannelEnabled('ADMIN')}
						onChange={toggleChannel('ADMIN')}
						disabled={disabled}
					/>
				</ListItemSecondaryAction>
			</ListItem>
			<ListItem divider>
				<ListItemText primary={t('common:salesChannel.inStore', 'In-Store (self service)')} />
				<ListItemSecondaryAction>
					<VisibilitySwitch
						checked={isChannelEnabled('STORE')}
						onChange={toggleChannel('STORE')}
						disabled={disabled}
					/>
				</ListItemSecondaryAction>
			</ListItem>
		</List>
	);
};

export default ChannelVisibilitySettings;
